interface Props {
  company: string;
  locale: string;
  values: Record<string, string | number>;
  insuranceLink: string;
  pensionLink: string;
}

export const fetchResult = async ({ company, locale, values, pensionLink, insuranceLink }: Props) => {
  const url = `${process.env.REACT_APP_API_URL}/2020/web/getresult.php?p=${company}${locale}`;
  const form = new URLSearchParams();
  form.append("savedCodes", JSON.stringify(values));

  const response = await fetch(url, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    method: "POST",
    body: form,
  });

  const responseText = (await response.text()).replace(/\n/g, " ");

  const externalLinks = responseText.match(/(?<=href=")(.*?)(?=")/g);

  if (!externalLinks) return responseText.split("§") as [string, string];

  return externalLinks
    .reduce((acc, link) => {
      const isInsuranceLink = link.indexOf("insurance") > -1;
      const replacementLink = isInsuranceLink ? insuranceLink : pensionLink;
      return acc.replace(link, replacementLink);
    }, responseText)
    .split("§") as [string, string];
};
